module.exports = __webpack_public_path__ + "static/media/pageLoader.d8fb4c14.svg";